import React from 'react'
import { useIntl } from 'react-intl'
import { Draggable } from 'react-beautiful-dnd'
import { Box, useTheme } from '@mui/system'
import DndIcon from '../../../../../assets/icons/Dnd.svg'

function DndItem({ item, index }) {
    const theme = useTheme()
    const { formatMessage } = useIntl()
    const styles = (snapshot) => {
        return {
            icon: {
                marginRight: '16px',
                padding: '4px',
                borderRadius: '50%',
                background: snapshot.isDragging
                    ? theme.palette.grey[100]
                    : '#fff',
                '&:hover': {
                    background: theme.palette.grey[100],
                },
            },

            dndItem: {
                background: snapshot.isDragging
                    ? '#d8e6f3'
                    : theme.palette.grey[100],
                p: 2,
                // width: 660,
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                borderRadius: 1,
                justifyContent: 'space-between',
            },

            iconStyle: {
                marginRight: 16,
                width: 24,
            },

            buttonGroups: {
                display: 'flex',
                alignItems: 'flex-start',
                gap: 1,
                ml: 2,
            },

            addQuestionButton: {
                background: '#C1DEFF',
                color: '#404A51',
                textTransform: 'none',
                padding: '2 12',
                borderRadius: 3,
            },

            iconButtonBackground: {
                background: '#f3f4f5',
            },

            boxContainer: {
                display: 'flex',
                alignItems: 'center',
                mb: 2,
                width: '100%',
            },
        }
    }

    return (
        <Draggable
            draggableId={`${item.courseTopicId}`}
            index={index}
        >
            {(provided, snapshot) => (
                <Box
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    sx={styles(snapshot).boxContainer}
                >
                    <Box
                        {...provided.dragHandleProps}
                        sx={styles(snapshot).icon}
                    >
                        <img
                            src={DndIcon}
                            alt="menu"
                        />
                    </Box>

                    <Box sx={styles(snapshot).dndItem}>
                        <Box>
                            {item.titleKz} / {item.titleRu}
                        </Box>
                        <Box>
                            {formatMessage({ id: 'group' })}: {item.language}
                        </Box>
                    </Box>
                </Box>
            )}
        </Draggable>
    )
}
export default DndItem
